<template>
    <div class="login-wrapper">
        <header-title
          :title="$t('menu.karadaNote')"
        />
        <router-link to="/Karada-Diary">
        <heading class="login-button" :title="$t('notebook.EnterInfo')" />
        </router-link>
    </div>
</template>

<script>
import HeaderTitle from '../design/HeaderTitleSlot'
import Heading from '../components/atoms/Heading'

export default {
  components: {
    HeaderTitle,
    Heading
  }
}
</script>

<style scoped>
  .login-wrapper {
      min-height: 100vh;
      width: 80vw;
      margin: auto;
  }
  .login-button {
      text-align: center;
      font-weight: bold;
  }
  a:hover {
      text-decoration: none;
  }
</style>

